module.exports = __webpack_public_path__ + "img/homeSec01Top4.f1c5709a.jpg";